import { UsersIcon } from "features/dashboard/components/icons/UsersIcon";
import { FileIcon } from "features/dashboard/components/icons/FileIcon";
import { PhoneIcon } from "features/dashboard/components/icons/PhoneIcon";
import { FileSendIcon } from "features/dashboard/components/icons/FileSendIcon";
import { CalendarIcon } from "features/dashboard/components/icons/CalendarIcon";
import { FileCheckIcon } from "features/dashboard/components/icons/FileCheckIcon";
import { UserCheckIcon } from "features/dashboard/components/icons/UserCheckIcon";

export const METRICS_CONFIG = [
  {
    key: "prospects",
    testId: "prospects",
    label: "Prospects",
    icon: <UsersIcon />,
    color: "var(--gray-200)",
    bgColor: "var(--gray-200-10)",
    description:
      "Candidates marked as Prospect - Sourced, Second Contacted, or Third Contacted, with a First, Second, or Third Contact Date in the current week to date.",
  },
  {
    key: "applicants",
    testId: "applicants",
    label: "Applicants",
    icon: <FileIcon />,
    color: "var(--pink-100)",
    bgColor: "var(--pink-100-10)",
    description:
      "Candidates marked as Candidates - Needs Review with an Applied Date in the current week to date.",
  },
  {
    key: "phoneScreens",
    testId: "phone-screens",
    label: "Phone Screens",
    icon: <PhoneIcon />,
    color: "var(--orange-300)",
    bgColor: "var(--orange-300-10)",
    description:
      "Candidates marked as S2 Interview - Complete with a Phone Screen Complete Date in the current week to date.",
  },
  {
    key: "submittals",
    testId: "submittals",
    label: "Submittals",
    icon: <FileSendIcon />,
    color: "var(--cyan-300)",
    bgColor: "var(--cyan-300-10)",
    description:
      "Candidates marked as Submitted - Awaiting Feedback with a Date Submitted in the current week to date.",
  },
  {
    key: "interviews",
    testId: "interviews",
    label: "Interviews",
    icon: <CalendarIcon />,
    color: "var(--purple-100)",
    bgColor: "var(--purple-100-10)",
    description:
      "Candidates marked as Client Interview - Awaiting Feedback with an Interview Date in the current week to date.",
  },
  {
    key: "offers",
    testId: "offers",
    label: "Offers",
    icon: <FileCheckIcon />,
    color: "var(--green-100)",
    bgColor: "var(--green-100-10)",
    description:
      "Candidates marked as Offer - Extended with an Offer Extended Date in the current week to date.",
  },
  {
    key: "hires",
    testId: "hires",
    label: "Hires",
    icon: <UserCheckIcon />,
    color: "var(--green-300)",
    bgColor: "var(--green-300-10)",
    description:
      "Candidates marked as Hired - Started Work with a Start Date in the current week to date.",
  },
];
